module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-0977.f03fcc6d.jpg";